<template>
  <el-dialog
    class="create-spv-node common-dialog"
    title="创建SPV节点"
    :visible.sync="showDialog"
    top="15vh"
    @open="onShow"
    @closed="onClosed"
  >
    <el-form
      ref="createSpvNode"
      :model="model"
      :rules="rules"
      :label-width="`${adaptationVars.formLabelWidth}px`"
    >
      <el-form-item label="IP地址" prop="serverIP" placeholder="请输入IP地址">
        <el-input v-model="model.serverIP" placeholder="请输入IP地址"></el-input>
      </el-form-item>
      <el-form-item label="Web端口" prop="webPort">
        <el-input v-model="model.webPort" placeholder="请输入Web端口"></el-input>
      </el-form-item>
      <el-form-item label="GRPC端口" prop="grpcPort">
        <el-input v-model="model.grpcPort" placeholder="请输入GRPC端口"></el-input>
      </el-form-item>
      <el-form-item
        v-for="(cItem, index) in model.chains"
        :key="index"
        :label="index == 0 ? '选择区块链' : ''"
        :prop="`chains.${index}`"
        :rules="Object.assign({}, chainItemRule)"
      >
        <div class="chain-form-item">
          <el-select
            v-model="cItem.chainId"
            placeholder="请选择区块链"
            class="chain-select"
            @change="chainChange(index)"
          >
            <el-option
              v-for="item in chainOptions"
              :key="item.ChainId"
              :label="item.ChainName"
              :value="item.ChainId"
            >
            </el-option>
          </el-select>

          <el-select
            v-model="cItem.orgId"
            placeholder="请选择组织"
            class="org-select"
            @change="orgChange(index)"
          >
            <el-option
              v-for="item in cItem.orgOptions"
              :key="item.OrgId"
              :label="item.OrgName"
              :value="item.OrgId"
            >
            </el-option>
          </el-select>

          <el-select v-model="cItem.nodeId" placeholder="请选择节点" class="node-select">
            <el-option
              v-for="item in cItem.nodeOptions"
              :key="item.NodeId"
              :label="item.NodeName"
              :value="item.NodeId"
            >
            </el-option>
          </el-select>

          <el-select v-model="cItem.userId" placeholder="请选择用户" class="user-select">
            <el-option
              v-for="item in cItem.userOptions"
              :key="item.UserId"
              :label="item.UserName"
              :value="item.UserId"
            >
            </el-option>
          </el-select>

          <el-button v-if="model.chains.length > 1" @click="removeAChainItem(index)"
            >删除</el-button
          >
        </div>
      </el-form-item>

      <el-form-item>
        <el-button class="add-chain-item" @click="addAChainItem">添加区块链</el-button>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="cacel">取 消</el-button>
      <el-button type="primary" @click="makeSure">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
import adaptation from '@/mixins/adaptation'
import { mapState, mapActions } from 'vuex'
export default {
  name: 'CreateSpvNode',
  mixins: [adaptation],
  adaptationVarsDefine: {
    formLabelWidth: 140
  },
  props: {
    dialogVisible: Boolean
  },
  data() {
    let validateAddr = (rule, value, callback) => {
      let reg = /^((2[0-4]\d|25[0-5]|[01]?\d\d?)\.){3}(2[0-4]\d|25[0-5]|[01]?\d\d?)$/
      if (value === '') {
        callback(new Error('请输入IP地址'))
      } else if (!reg.test(value)) {
        callback(new Error('请输入正确的IP地址'))
      } else {
        callback()
      }
    }
    let validateWebPort = (rule, value, callback) => {
      let reg = /^\d+$/
      if (value === '') {
        callback(new Error('请输入Web端口'))
      } else if (!reg.test(value)) {
        callback(new Error('请输入正确的Web端口'))
      } else {
        callback()
      }
    }
    let validateGRPCPort = (rule, value, callback) => {
      let reg = /^\d+$/
      if (value === '') {
        callback(new Error('请输入GRPC端口'))
      } else if (!reg.test(value)) {
        callback(new Error('请输入正确的GRPC端口'))
      } else {
        callback()
      }
    }
    let validateChainItem = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请添加区块链信息'))
      } else if (!value.chainId) {
        callback(new Error('请选择区块链'))
      } else if (!value.orgId) {
        callback(new Error('请选择组织'))
      } else if (!value.nodeId) {
        callback(new Error('请选择节点'))
      } else if (!value.userId) {
        callback(new Error('请选择用户'))
      } else {
        callback()
      }
    }
    return {
      model: {
        chains: [
          {
            chainId: null,
            orgId: null,
            nodeId: null,
            userId: null,
            orgOptions: [],
            nodeOptions: [],
            userOptions: []
          }
        ],
        chainOptionsRaw: [],
        serverIP: null,
        grpcPort: null,
        webPort: null
      },
      rules: {
        serverIP: [{ required: true, validator: validateAddr, trigger: ['blur', 'change'] }],
        webPort: [{ required: true, validator: validateWebPort, trigger: ['blur', 'change'] }],
        grpcPort: [{ required: true, validator: validateGRPCPort, trigger: ['blur', 'change'] }]
      },
      chainItemRule: {
        required: true,
        validator: validateChainItem,
        trigger: 'change'
      },
      showDialog: false,
      adaptationVars: {
        formLabelWidth: 140
      }
    }
  },
  computed: {
    chainOptions: function() {
      let chains = this.model.chains
      return this.model.chainOptionsRaw.filter(e => !chains.some(c => c.chainId == e.ChainId))
    }
  },
  watch: {
    dialogVisible: function(val) {
      this.showDialog = val
    },
    showDialog: function(val) {
      this.$emit('update:dialogVisible', val)
    }
  },
  mounted() {},
  methods: {
    cacel() {
      this.showDialog = false
    },
    makeSure() {
      let self = this
      this.$refs.createSpvNode.validate(valid => {
        if (valid) {
          console.log('submit!')
          let chains = self.model.chains.map(e => {
            return {
              chainId: e.chainId,
              nodeId: e.nodeId,
              userId: parseInt(e.userId)
            }
          })

          self.$apis.spvlightnodes
            .createSpvNode({
              chains: chains,
              grpcPort: parseInt(self.model.grpcPort),
              serverIP: self.model.serverIP,
              webPort: parseInt(self.model.webPort)
            })
            .then(res => {
              if (res && res.data && self.$utils.isNumber(res.data.SpvId)) {
                self.showDialog = false

                self.$emit('createSuccess')
                self.$message({
                  type: 'success',
                  message: '创建SPV节点成功!'
                })
              } else {
                self.$message({
                  type: 'error',
                  message: '创建SPV节点失败!'
                })
              }
              console.log(res)
            })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    onShow() {
      this.getChains()
    },
    onClosed() {
      this.$refs.createSpvNode.clearValidate()
    },
    getChains() {
      let self = this
      this.$apis.home.getSubscribeQueryList({}).then(res => {
        if (res.data && res.data.items) {
          //DPOS共识类型的链，不可在SPV轻节点管理中选择
          let items = res.data.items.filter(e => {
            return e.Consensus != 'DPOS'
          })
          self.model.chainOptionsRaw = items

          if (items.length === 0) {
            self.$message.warning('请订阅区块链！')
          }
        }
      })
    },
    chainChange(index) {
      let param = {
        offset: 0,
        limit: 50,
        chainId: this.model.chains[index].chainId
      }
      let self = this
      this.$apis.chain.getChainOrgList(param).then(res => {
        if (res.data && res.data.items) {
          self.model.chains[index].orgOptions = res.data.items
        }
      })
    },
    //获取节点
    ...mapActions(['getChainNodeLists']),
    orgChange(index) {
      let orgId = this.model.chains[index].orgId
      let params = {
        offset: 0,
        limit: 100,
        chainId: this.model.chains[index].chainId,
        orgId: orgId
      }
      let self = this
      //获取节点列表
      this.getChainNodeLists(params).then(res => {
        if (res.items) {
          self.model.chains[index].nodeOptions = res.items
        }
      })
      //获取用户列表
      this.$apis.certificate.getUserListByOrg({ OrgId: orgId }).then(res => {
        if (res.data && res.data.items) {
          self.model.chains[index].userOptions = res.data.items
        }
      })
    },
    addAChainItem() {
      this.model.chains.push({
        orgOptions: [],
        nodeOptions: [],
        userOptions: []
      })
    },
    removeAChainItem(index) {
      this.model.chains.splice(index, 1)
    }
  }
}
</script>
<style scoped lang="scss">
@import '@/styles/variables/theme';
@import '@/styles/variables/adaptation';

@include theme('create-spv-node', (), ());
.create-spv-node {
  @include adaptation((
    --chain-form-item-margin-left: 8px
  ));
  /deep/ .el-dialog {
    width: var(--common-dialog-large-width);
  }

  .el-form {
    margin-right: var(--common-dialog-form-margin-right);

    .el-form-item {
      .chain-form-item {
        display: flex;

        :not(:first-child) {
          margin-left: var(--chain-form-item-margin-left);
        }
      }

      .add-chain-item {
        width: 100%;
        border: var(--base-border-width) dashed var(--base-border-color-lighter);
      }
    }
  }
}
</style>
